module.exports = __webpack_public_path__ + "static/media/img2-2.9ed31293.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/nogal/nutricheck_foliar/ZN/img2-2.png
// module id = 1961
// module chunks = 3